import * as React from 'react';
import { SVGProps } from 'react';

const IconStratigraphySizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 7.226v-3.14l.026-.009.041-.014C2.811 3.815 3.756 3.5 5 3.5c1.244 0 2.189.315 2.933.563l.041.014c.75.25 1.294.423 2.026.423.742 0 1.4-.175 2.336-.425l.09-.024c.471-.126.992-.262 1.574-.367v3.063c-.265.061-.53.13-.801.202l-.186.05c-.852.23-1.864.501-3.013.501-1.244 0-2.189-.315-2.933-.563l-.041-.014C6.276 6.673 5.732 6.5 5 6.5c-.732 0-1.276.173-2.026.423l-.041.014c-.28.093-.59.197-.933.289Z"
      fill="var(--color-typo-success)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 10.226v-3.14l.026-.009.041-.014C2.811 6.815 3.756 6.5 5 6.5c1.244 0 2.189.315 2.933.563l.041.014c.75.25 1.294.423 2.026.423.742 0 1.4-.175 2.336-.425l.09-.024c.471-.126.992-.262 1.574-.367v3.063c-.265.061-.53.13-.801.202l-.186.05c-.852.23-1.864.501-3.013.501-1.244 0-2.189-.315-2.933-.563l-.041-.014C6.276 9.673 5.732 9.5 5 9.5c-.732 0-1.276.173-2.026.423l-.041.014c-.28.094-.59.197-.933.289Z"
      fill="var(--color-typo-caution)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 13.226v-3.14l.026-.009.041-.014C2.811 9.815 3.756 9.5 5 9.5c1.244 0 2.189.315 2.933.563l.041.014c.75.25 1.294.423 2.026.423.742 0 1.4-.175 2.336-.425l.09-.024c.471-.126.992-.262 1.574-.367v3.063c-.265.061-.53.13-.801.202l-.186.05c-.852.23-1.864.501-3.013.501-1.244 0-2.189-.315-2.933-.563l-.041-.014c-.75-.25-1.294-.423-2.026-.423-.732 0-1.276.173-2.026.423l-.041.014c-.28.094-.59.197-.933.289Z"
      fill="var(--color-typo-warning)"
    />
  </svg>
);
export default IconStratigraphySizeS;
